import { useEffect } from "react";

import { useLocation } from "react-router-dom";

import { Config } from "@/config/Config";

declare global {
	interface Window {
		dataLayer?: unknown[];
	}
}

let injected = false;

// Injects GTM when VITE_GOOGLE_ANALYTICS_ID is set and pushes a page_view on
// every route change.
export function initAnalytics() {
	if (injected || !Config.google_analytics_id) {
		return;
	}
	injected = true;
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		"gtm.start": new Date().getTime(),
		"event": "gtm.js",
	});
	const script = document.createElement("script");
	script.async = true;
	script.src = `https://www.googletagmanager.com/gtm.js?id=${Config.google_analytics_id}`;
	document.head.appendChild(script);
}

export function usePageTracking() {
	const location = useLocation();

	useEffect(() => {
		if (!Config.google_analytics_id) {
			return;
		}
		window.dataLayer?.push({
			event: "page_view",
			page_path: location.pathname + location.search,
		});
	}, [location.pathname, location.search]);
}
